import { DNA } from 'react-loader-spinner';

const LoadingIndicator = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <DNA
        visible={true}
        height="100"
        width="100"
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
      />
    </div>
  );
};

export default LoadingIndicator;
